import { Constants } from "./crucialData";

export const pensionTagsTranslations: Record<string, string> = {
  'איילון חברה לביטוח בע"מ': "איילון חברה לביטוח",
  "איילון מיטב פנסיה כללית": "איילון מיטב פנסיה כללית",
  "איילון מיטב פנסיה מקיפה": "איילון מיטב פנסיה מקיפה",
  'אינפיניטי השתלמות, גמל ופנסיה בע"מ': "אינפיניטי",
  'אלטשולר שחם גמל ופנסיה בע"מ': "אלטשולר שחם",
  'אנליסט קופות גמל בע"מ': "אנליסט",
  'גל -ניהול קופות גמל לעובדי הוראה בע"מ': "גל גמל לעובדי הוראה",
  'גלובלנט ניהול קופות גמל ג.נ.נ.ק.ג בע"מ': "גלובלנט",
  'הכשרה חברה לביטוח בע"מ': "הכשרה חברה לביטוח",
  'הפניקס חברה לביטוח בע"מ': "הפניקס חברה לביטוח",
  'הפניקס פנסיה וגמל בע"מ': "הפניקס פנסיה וגמל",
  'הראל חברה לביטוח בע"מ': "הראל חברה לביטוח",
  'הראל פנסיה וגמל בע"מ': "הראל פנסיה וגמל",
  'ילין לפידות ניהול קופות גמל בע"מ': "ילין לפידות",
  'ישיר -איי. די. איי. חברה לביטוח בע"מ': "ישיר -איי. די. איי.",
  'כלל חברה לביטוח בע"מ': "כלל חברה לביטוח",
  'כלל פנסיה וגמל בע"מ': "כלל פנסיה וגמל",
  'מגדל חברה לביטוח בע"מ': "מגדל חברה לביטוח",
  'מגדל מקפת קרנות פנסיה וקופות גמל בע"מ': "מגדל פנסיה וגמל",
  'מור גמל ופנסיה בע"מ': "מור גמל ופנסיה",
  'מיטב גמל ופנסיה בע"מ': "מיטב גמל ופנסיה",
  'מנורה מבטחים חברה לביטוח בע"מ': "מנורה מבטחים חברה לביטוח",
  'מנורה מבטחים פנסיה וגמל בע"מ': "מנורה מבטחים פנסיה וגמל",
  'סלייס גמל בע"מ': "סלייס גמל",
  'קרן החסכון לצבא הקבע - חברה לניהול קופות גמל בע"מ': "קרן החסכון לצבא הקבע",
};

export const productTypesTranslations: Record<string, string> = {
  [Constants.POLICIES_1990_1991]: Constants.SAVING_POLICIES_MANAGER_INSURANCE,
  [Constants.POLICIES_1992_2003]: Constants.SAVING_POLICIES_MANAGER_INSURANCE,
  [Constants.POLICIES_2004]: Constants.SAVING_POLICIES_MANAGER_INSURANCE,
  "קופת גמל להשקעה": "גמל להשקעה",
  "קופת גמל להשקעה - חסכון לילד": "חסכון לכל ילד",
  "קרנות השתלמות": "קרן השתלמות",
  "קרן השתלמות": "קרן השתלמות",
  "קופת גמל": "קופת גמל",
  
  "קרנות חדשות": "פנסיה מקיפה",
  "קרנות כלליות": "פנסיה כללית",
  "תגמולים ואישית לפיצויים": "קופת גמל",
  "פוליסת ביטוח חיים משולב חיסכון": "פוליסת ביטוח חיים משולב חיסכון",
  "פוליסת חסכון טהור": "פוליסת חיסכון / ביטוח מנהלים",
};
